import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  background: #3D3D3D;

  a {
    color: #B8B8B8;
    font-size: 16px;
    margin-right: 32px;
    text-decoration: none;
    padding: 15px 0 15px 0;
    border-bottom: solid 2px transparent;

    &.selected {
      color: #FFFFFF;
      border-color: #FFC709;

    }
  }
`;
